import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BioSummary = ({ summary, summaryTitle }) => {
    return (_jsxs("div", { className: "bio-summary", children: [_jsx("h2", { className: "bio-summary__title", children: summaryTitle }), _jsx("div", { className: "bio-summary__rich-editor", dangerouslySetInnerHTML: { __html: summary } })] }));
};
export default BioSummary;
